// extracted by mini-css-extract-plugin
module.exports = {"button":"_17OxJ","flexContainer":"_3vm-B","count":"_2jurR","switchCounterAndButton":"VQmZB"};